import React, { useEffect, useState } from "react";
import "../cards/cards.css";
import QuizWallicon from "../../../../assets/svg/QuizWallicon";


const Processing = () => {
  return (
    <>
      <div className={"box_container1_procecing"}>
        <div className={"store_box_container_top_logo absoluteTop"}>
          <QuizWallicon width={143} height={31} />
        </div>
        <div className="processingBox">
          <div className="procesingGIf">
            <img src="https://bonus-video.b-cdn.net/67ee00d6d66c5b499e87cf240ca6fa41ebb8626f.gif"/>
          </div>
          <h2 className="processText">PROCESSING...</h2>
        </div>
      </div>

    </>
  );
};

export default Processing;
